import { useEffect, useState } from "react";

/**
 * Re-renders only when the query starts or stops matching, unlike
 * `useWindowSize` which updates on every resize tick.
 */
const useMediaQuery = (query: string) => {
    const [matches, setMatches] = useState(
        () => window.matchMedia(query).matches,
    );

    useEffect(() => {
        const list = window.matchMedia(query);
        const update = () => setMatches(list.matches);
        update();
        try {
            list.addEventListener("change", update);
            return () => list.removeEventListener("change", update);
        } catch {
            // Fallback for browsers that do not support addEventListener on MediaQueryList
            list.addListener(update);
            return () => list.removeListener(update);
        }
    }, [query]);

    return matches;
};

export default useMediaQuery;
